import Icon from '@ant-design/icons';
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import { ReactComponent as VectorIconSvg } from '../../assets/vector-icon.svg';

export const VectorIcon = (props: Partial<CustomIconComponentProps>) => {
  return <Icon component={VectorIconSvg} {...props} />;
};
